import interceptor from "@/plugins/interceptor";
const pathController = "/Stuff";

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    async stuff_postConsultation(_, obj) {
      return await interceptor.authenticate.post(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/consultation`,
        obj
      );
    },
    async stuff_onboarding() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/onboarding`
      );
    },
    async preRegistration_creationOptions() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${pathController}/creationOptions`
      );
    },
    async stuff_tutors() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${pathController}/tutors`
      );
    },
    async stuff_tutors_site_api() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/tutors`
      );
    },
    async stuff__date() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/date`
      );
    },
    async stuff__countries() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/countries`
      );
    },
    async stuff_roles() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_ADMIN_URL}${pathController}/roles`
      );
    },
    async stuff_linkPreview(_,obj) {
      return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_URL}${pathController}/linkPreview`, obj);  
    },
    async stuff_saveCertificateTemplate(_,obj) {
      return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_UTILS_URL}${pathController}/saveCertificateTemplate`, obj);
    },
  },
};
